import { ProjectStoreService } from '@modules/projects/shared/services/project-store.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProjectsConfiguratorComponent } from '@modules/projects/modules/projects-configurator/projects-configurator.component';
import { ProjectCreatorDeactivateComponent } from '@modules/project-creator/pages/project-creator-manage/components/project-creator-deactivate/project-creator-deactivate.component';
import { Config } from '@shared/configs/config';
import { MatDialog } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class CanDeactivateProjectCreation {
  constructor(
    private service: ProjectStoreService,
    private dialog: MatDialog
  ) {}

  canDeactivate(
    component: ProjectsConfiguratorComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): any {
    if (!!currentRoute?.data?.create) {
      if (!this.service.projectCreated) {
        return new Promise((resolve, reject) => {
          if (!component?.configurator?.isCurrentStepUnsaved) {
            return resolve(true);
          }
          this.dialog
            .open(ProjectCreatorDeactivateComponent, {
              width: Config.DEFAULT_MODAL_WIDTH,
              autoFocus: false,
              data: { viewState: 'create' }
            })
            .afterClosed()
            .subscribe((value) => resolve(!!value));
        });
      }
    } else {
      if (!!component?.configurator?.isCurrentStepUnsaved) {
        return new Promise((resolve, reject) => {
          this.dialog
            .open(ProjectCreatorDeactivateComponent, {
              width: Config.DEFAULT_MODAL_WIDTH,
              autoFocus: false,
              data: { viewState: 'edit' }
            })
            .afterClosed()
            .subscribe((value) => resolve(!!value));
        });
      }
    }

    return true;
    // return confirm(
    //   this.t.instant(
    //     !!currentRoute?.data?.edit ? 'Projects.leaveProjectEdit' : 'Projects.leaveProjectCreation',
    //   ),
    // );
  }
}
